import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DummyCheckboxService {

    public get isDummy(): boolean {
        return localStorage.getItem('isDummy') === "true";
    }

    public set isDummy(input: boolean) {
        localStorage.setItem('isDummy', String(input));
    }
}